// extracted by css-extract-rspack-plugin
export default {"cls1":"Reader-cls1_eve","cls2":"Reader-cls2_2YI Reader-cls1_eve"};